import { gql, useMutation } from '@apollo/client';

import { useBookForVacation } from '@views/Book/Book/BasicBook/Booking/hooks';

import {
  BasicBooking,
  BookingHooksBasicProps,
  CreateBookingResponse,
} from '@views/shared/interfaces/booking';

export const bookVacationMutation = gql`
  mutation bookVacation($start: DateTime!, $end: DateTime!, $comment: String) {
    createBooking: createVacationBooking(
      booking: { start: $start, end: $end, comment: $comment }
    ) {
      vacation
      start
      end
      comment
    }
  }
`;

export function useBook({
  date,
  enabledHalfDayBooking,
  enabledHourlyBooking,
  hasNextDaysBooking,
  formats,
  t,
  type,
  params,
}: BookingHooksBasicProps) {
  const mutation = useMutation<
    { createBooking: CreateBookingResponse },
    BasicBooking
  >(bookVacationMutation);

  return useBookForVacation({
    date,
    enabledHalfDayBooking,
    enabledHourlyBooking,
    hasNextDaysBooking,
    t,
    type,
    params,
    formats,
    bookingMutation: mutation,
  });
}
